
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { ISupplierModel, SupplierProductModel } from "@/api/types";
import {
  postSupplierCardsExcel,
  getsupplierCardsList,
  editSupplierCards,
  deleteSupplierCards,
} from "@/api/supplier";
import { Form } from "element-ui";
import Template from "@/views/system-management/template/index.vue";

@Component({
  name: "SupplierManagement",
  components: {
    Template,
    Pagination,
  },
})
export default class extends Vue {
  public table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    supplierName: null, // 供应商
    clerk: null, // 业务员
    legalRepresentative: null, // 法人代表
    list: [] as any,
  };
  private tableKey = 0;
  private suppliers: ISupplierModel[] = [];
  private supplierProducts: SupplierProductModel[] = [];
  private total = 0;
  private listLoading = true;
  private dialogFormVisible = false;
  private popoverVisible = false;
  private dialogStatus = "";
  private textMap = {
    update: "编辑",
    create: "新增",
  };
  private showFileList = false;
  private dialogPageViewsVisible = false;
  private supplierProductVisible = false;
  private pageViewsData = [];
  private payload = new WriteSupplierInput();
  private files: File[] = [];
  private rules = {
    code: [{ required: true, message: "编号不能为空", trigger: "blur" }],
    name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
    address: [{ required: true, message: "公司地址不能为空", trigger: "blur" }],
  };
  public tableCol = [
    {
      label: "供应商名称",
      prop: "name",
      key: "name",
      show: true,
      disabled: false,
    },
    {
      label: "供应商编号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "公司地址",
      prop: "address",
      key: "address",
      show: true,
      disabled: false,
    },
    {
      label: "联系电话",
      prop: "telephone",
      key: "telephone",
      show: true,
      disabled: false,
    },
    {
      label: "传真电话",
      prop: "faxTelephone",
      key: "faxTelephone",
      show: true,
      disabled: false,
    },
    {
      label: "法人代表",
      prop: "legalRepresentative",
      key: "legalRepresentative",
      show: true,
      disabled: false,
    },
    {
      label: "业务员",
      prop: "clerk",
      key: "clerk",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑",
          code: "",
          click: "handleEdit",
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 280,
    },
  ] as any;
  private uploadType = "";

  created() {
    this.getList();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    this.listLoading = true;
    let params = {
      pageNumber: 1,
      pageSize: 20,
      supplierName: null, // 供应商
      clerk: null, // 业务员
      legalRepresentative: null, // 法人代表
    };
    params.pageNumber = this.table.pageNumber;
    params.pageSize = this.table.pageSize;
    params.supplierName = this.table.supplierName;
    params.clerk = this.table.clerk;
    params.legalRepresentative = this.table.legalRepresentative;
    const res: any = await getsupplierCardsList(params);
    this.table.list = res.content;
    this.table.total = res.total;
    this.listLoading = false;
    this.loading = false;
  }

  private async clickSubmit() {
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  private async queryProduct(supplierProducts: SupplierProductModel[]) {
    this.supplierProducts = supplierProducts;
    this.supplierProductVisible = true;
  }

  private handleEdit(row) {
    this.payload = row.row;
    this.dialogStatus = "update";
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async handledelete(row) {
    // console.log('row',row)
    await deleteSupplierCards(row.row.id);
    this.dialogFormVisible = false;
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private addSpecialCharge(supplierProducts: SupplierProductModel[]) {
    const c = new SupplierProductModel();
    supplierProducts.push(c);
  }

  private async updateData() {
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        await editSupplierCards(this.payload.id, this.payload);
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000,
        });
        await this.getList();
      }
    });
  }

  private async cancelEdit() {
    this.dialogFormVisible = false;
    await this.getList();
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      this.$message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
      });
    }
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await postSupplierCardsExcel(formData);
    await this.getList();
  }
}

class WriteSupplierInput {
  name: string;
  code: string;
  address: string;
  telephone: string;
  faxTelephone: string;
  legalRepresentative: string;
  clerk: string;
  id: any;
}
